<template>
  <div class="policy">
    <div class="current">当前位置：政策扶持</div>
    <div class="policyBox" v-for="i in policyData" :key="i.noticeId">
      <div @click="policyInfo(i)">
        <div
          style="
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            cursor: pointer; /*鼠标变小手*/
          "
        >
          {{ i.title }}
        </div>
        <div
          style="
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #9e9e9e;
            margin-top: 20px;
            margin-bottom: 27px;
          "
        >
          {{ i.noticeDesc }}
        </div>
      </div>

      <div style="display: flex; align-items: center">
        <img src="../assets/other/time.png" style="width: 24px; height: 24px" />
        <span
          style="
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #9e9e9e;
            margin-left: 10px;
          "
          >{{ i.createTime }}</span
        >
      </div>
    </div>
    <el-pagination
      class="pagination"
      background
      :pageSize="pageSize"
      layout="prev, pager, next"
      :total="total"
      :currentPage="pageNum"
      @current-change="currentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { information, informationId } from "../api/home";
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 5,
      noticeType: 4,
      total: 0,
      policyData: [],
    };
  },
  methods: {
    currentChange(val) {
      console.log("aaaa", val);
      this.pageNum = val;
      this.getPolicy();
    },
    getPolicy() {
      information({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        noticeType: this.noticeType,
      }).then((res) => {
        if (res.code == 200) {
          this.total = res.data.total;
          this.policyData = res.data.rows;
        }
      });
    },
    policyInfo(i) {
      this.$router.push({
        name: "policyInfo",
        params: {
          noticeId: i.noticeId,
          type: "policy",
        },
      });
    },
  },
  created() {
    this.getPolicy();
  },
};
</script>

<style lang="less" scoped>
.policy {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0px 180px 0px;
  .pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 100px;
  }
  .current {
    padding: 30px 0;

    border-bottom: 1px dashed #cccccc;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9e9e9e;
  }
  .policyBox {
    padding: 51px 0 25px 0;
    border-bottom: 1px solid #cccccc;
  }
}
</style>